/* tslint:disable */
export default {
    IMAGES_DATA_KEY: "images",
    AUDIOS_DATA_KEY: "audios",
    SPRITE_SHEETS_DATA_KEY: "spriteSheets",
    SPINE_ANIMATION_DATA_KEY: "spineAnimations",
    images: {
        howToPlayCloseBase: "src/assets/images/buttons/howToPlayClose/base.png",
        howToPlayCloseHover: "src/assets/images/buttons/howToPlayClose/hover.png",
        howToPlayCloseClick: "src/assets/images/buttons/howToPlayClose/click.png",
        infoBase: "src/assets/images/buttons/info/base.png",
        infoHover: "src/assets/images/buttons/info/hover.png",
        infoClick: "src/assets/images/buttons/info/click.png",
        infoInactive: "src/assets/images/buttons/info/inActive.png",
        settingCheckboxOffBase: "src/assets/images/buttons/settingCheckbox/offBase.png",
        settingCheckboxOffHover: "src/assets/images/buttons/settingCheckbox/offHover.png",
        settingCheckboxOnBase: "src/assets/images/buttons/settingCheckbox/onBase.png",
        settingCheckboxOnHover: "src/assets/images/buttons/settingCheckbox/onHover.png",
        maxBetBase: "src/assets/images/buttons/maxBet/base.png",
        maxBetHover: "src/assets/images/buttons/maxBet/hover.png",
        maxBetOnClick: "src/assets/images/buttons/maxBet/onClick.png",
        maxBetInactive: "src/assets/images/buttons/maxBet/inactive.png",
        doubleUpButtonBase: "src/assets/images/buttons/doubleUp/base.png",
        doubleUpButtonHover: "src/assets/images/buttons/doubleUp/hover.png",
        doubleUpButtonOnClick: "src/assets/images/buttons/doubleUp/click.png",
        doubleUpButtonInactive: "src/assets/images/buttons/doubleUp/inActive.png",
        payTableArrowBase: "src/assets/images/buttons/arrow/base.png",
        payTableArrowHover: "src/assets/images/buttons/arrow/hover.png",
        payTableArrowClick: "src/assets/images/buttons/arrow/click.png",
        payTableArrowInActive: "src/assets/images/buttons/arrow/inActive.png",
        volumeOffBase: "src/assets/images/buttons/volume/offBase.png",
        volumeOffHover: "src/assets/images/buttons/volume/offHover.png",
        volumeOffClick: "src/assets/images/buttons/volume/offClick.png",
        volumeOffInActive: "src/assets/images/buttons/volume/offInActive.png",
        volumeOnBase: "src/assets/images/buttons/volume/onBase.png",
        volumeOnHover: "src/assets/images/buttons/volume/onHover.png",
        volumeOnClick: "src/assets/images/buttons/volume/onClick.png",
        volumeOnInActive: "src/assets/images/buttons/volume/onInActive.png",
        speedOffBase: "src/assets/images/buttons/speed/offBase.png",
        speedOffHover: "src/assets/images/buttons/speed/offHover.png",
        speedOffClick: "src/assets/images/buttons/speed/offClick.png",
        speedOffInActive: "src/assets/images/buttons/speed/offInActive.png",
        speedOnBase: "src/assets/images/buttons/speed/onBase.png",
        speedOnHover: "src/assets/images/buttons/speed/onHover.png",
        speedOnClick: "src/assets/images/buttons/speed/onClick.png",
        speedOnInActive: "src/assets/images/buttons/speed/onInActive.png",
        settingsBase: "src/assets/images/buttons/settings/base.png",
        settingsHover: "src/assets/images/buttons/settings/hover.png",
        settingsClick: "src/assets/images/buttons/settings/click.png",
        settingsInActive: "src/assets/images/buttons/settings/inActive.png",
        optionsBase: "src/assets/images/buttons/options/base.png",
        optionsHover: "src/assets/images/buttons/options/hover.png",
        optionsClick: "src/assets/images/buttons/options/click.png",
        optionsInActive: "src/assets/images/buttons/options/inActive.png",
        collectBase: "src/assets/images/buttons/collect/base.png",
        collectHover: "src/assets/images/buttons/collect/hover.png",
        collectClick: "src/assets/images/buttons/collect/click.png",
        collectInActive: "src/assets/images/buttons/collect/inActive.png",
        drawBase: "src/assets/images/buttons/draw/base.png",
        drawHover: "src/assets/images/buttons/draw/hover.png",
        drawClick: "src/assets/images/buttons/draw/click.png",
        drawInActive: "src/assets/images/buttons/draw/inActive.png",
        holdBase: "src/assets/images/buttons/hold/base.png",
        holdHover: "src/assets/images/buttons/hold/hover.png",
        holdClick: "src/assets/images/buttons/hold/click.png",
        holdInActive: "src/assets/images/buttons/hold/inActive.png",
        invisibleCardClickArea: "src/assets/images/buttons/invisibleCardClickArea/base.png",
        textFieldBackground: "src/assets/images/textFieldBackground.png",
        gameBackground: "src/assets/images/gameBackground.png",
        doubleUpGameBackground: "src/assets/images/doubleUpGameBackground.png",
        actionsButtonsBackground: "src/assets/images/actionsButtonsBackground.png",
        dealButtonBase: "src/assets/images/buttons/deal/base.png",
        dealButtonOnHover: "src/assets/images/buttons/deal/hover.png",
        dealButtonOnClick: "src/assets/images/buttons/deal/click.png",
        dealButtonInActive: "src/assets/images/buttons/deal/inactive.png",
        minusButtonBase: "src/assets/images/buttons/bet/minus/base.png",
        minusButtonOnHover: "src/assets/images/buttons/bet/minus/hover.png",
        minusButtonOnClick: "src/assets/images/buttons/bet/minus/click.png",
        minusButtonInActive: "src/assets/images/buttons/bet/minus/inActive.png",
        blackDoubleUpBase: "src/assets/images/buttons/blackDoubleUp/base.png",
        blackDoubleUpHover: "src/assets/images/buttons/blackDoubleUp/hover.png",
        blackDoubleUpClick: "src/assets/images/buttons/blackDoubleUp/click.png",
        blackDoubleUpInActive: "src/assets/images/buttons/blackDoubleUp/inActive.png",
        redDoubleUpBase: "src/assets/images/buttons/redDoubleUp/base.png",
        redDoubleUpHover: "src/assets/images/buttons/redDoubleUp/hover.png",
        redDoubleUpClick: "src/assets/images/buttons/redDoubleUp/click.png",
        redDoubleUpInActive: "src/assets/images/buttons/redDoubleUp/inActive.png",
        plusButtonBase: "src/assets/images/buttons/bet/plus/base.png",
        plusButtonOnHover: "src/assets/images/buttons/bet/plus/hover.png",
        plusButtonOnClick: "src/assets/images/buttons/bet/plus/click.png",
        plusButtonInActive: "src/assets/images/buttons/bet/plus/inActive.png",
        betPickerPanelBackground: "src/assets/images/betPickerPanelBackground.png",
        lightUnderCards: "src/assets/images/lightUnderCards.png",
        handValueBackground: "src/assets/images/handValueBackground.png",
        betValueBackground: "src/assets/images/betValueBackground.png",
        howToPlayPage1: "src/assets/images/howToPlayPage1.png",
        howToPlayPage2: "src/assets/images/howToPlayPage2.png",
        howToPlayPage3: "src/assets/images/howToPlayPage3.png",
        howToPlayPage4: "src/assets/images/howToPlayPage4.png",
        howToPlayPage5: "src/assets/images/howToPlayPage5.png",
        betPanelBackground: "src/assets/images/panel_background.png",
        paytable: "src/assets/images/paytable.png",
        heldLockerSymbol: "src/assets/images/heldLockerSymbol.png",
        doubleUpCardBackground: "src/assets/images/doubleUpCardBackground.png",
        doubleUpYouWonTextWithBg: "src/assets/images/doubleUpYouWonTextWithBg.png",
        settingsMenuBackground: "src/assets/images/settingsMenuBackground.png",
    },
    fonts: {
        RobotoCondensedRegular: "src/assets/fonts/RobotoCondensed-Regular.ttf",
        RobotoMedium: "src/assets/fonts/Roboto-Medium.ttf",
        RobotoRegular: "src/assets/fonts/Roboto-Regular.ttf",
    },
    spriteSheets: {},
    spineAnimations: {
        cardFront: "src/assets/spineAnimations/staticCardAnimation/staticCardAnimation.json",
        cardTurn: "src/assets/spineAnimations/cardTurnAnimation/cardTurnAnimation.json",
        doubleUpCurrentCardHighlight: "src/assets/spineAnimations/doubleUpCurrentCardHighlight/doubleUpCurrentCardHighlight.json",
        doubleUpText: "src/assets/spineAnimations/doubleUpTextAnimation/doubleUpText.json",
        winningDot: "src/assets/spineAnimations/winningDotAnimation/winningDot.json",
        winPopupAnimation: "src/assets/spineAnimations/winPopupAnimation/winPopupAnimation.json",
    },
    audios: {
        buttonClicked: "src/assets/audios/Buttons/Regular_buttons.ogg",
        collectButtonClicked: "src/assets/audios/Buttons/Collect.ogg",
        dealOrDrawButtonClicked: "src/assets/audios/Buttons/Deal_and_draw_button.ogg",
        dealingNormalSpeed: "src/assets/audios/Dealing_normal_speed.ogg",
        dealingFastSpeed2: "src/assets/audios/Dealing_fast_speed_2.ogg",
        holdOff: "src/assets/audios/Hold_off.ogg",
        holdOn: "src/assets/audios/Hold_on.ogg",
        winDoubleUp: "src/assets/audios/Win_double_up.ogg",
        regularWin: "src/assets/audios/Win_regular.ogg",
    },
    loadingScreen: {
        images: {
            loadingScreenLogo: "src/assets/images/loadingScreen/logo.png",
            loadingBarBack: "src/assets/images/loadingScreen/loading_bar_back.png",
            loadingBarCover: "src/assets/images/loadingScreen/loading_bar_cover.png",
        },
    },
};



// WEBPACK FOOTER //
// ./src/app/configs/data.ts